import { LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { WEB_COMPONENT_GZ_REMOVE_FROM_ISOLATION_TASK } from '../../../../../../webcomponents.constants';
import { translateFn } from '../../../../../../utils/translator.helper';
import { FontSizes } from '../../../../../../types/common/types';

/**
 * @summary Content of Remove From Isolation task pop-up.
 * @tag gz-remove-from-isolation-task
 */
@customElement(WEB_COMPONENT_GZ_REMOVE_FROM_ISOLATION_TASK)
export class GzRemoveFromIsolationTaskWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`<gz-text fontSize="${FontSizes.HEADING_6}">
      ${translateFn('This action will reconnect the endpoint to the network.')}
    </gz-text>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    WEB_COMPONENT_GZ_REMOVE_FROM_ISOLATION_TASK: GzRemoveFromIsolationTaskWebComponent;
  }
}
